<template>
  <div class="preview">
    <div class="preview__inner">
      <div class="preview__header">
        <el-row :gutter="20">
          <el-col :span="12">
            <h2>Signature preview</h2>
          </el-col>
          <el-col
            :span="6"
            style="text-align: right;"
          >
            <el-select
              v-model="selectCompany"
              placeholder="Select Company"
            >
              <el-option
                v-for="item in company.companies"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col
            :span="6"
            style="text-align: right;"
          >
            <el-select
              v-model="selectAddress"
              placeholder="Select Address"
              :disabled="isBranchAddressEmpty"
            >
              <el-option
                v-for="item in address.selectedBranchAddresses"
                :key="item.branch"
                :label="item.branch"
                :value="item.branch"
              />
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div class="email">
        <div
          ref="preview"
          class="email-preview"
        >
          <component
            :is="signatureTemplate"
            ref="template"
          />
        </div>
      </div>
      <div class="actions">
        <el-button-group>
          <el-button
            size="small"
            :disabled="isSelectAddressEmpty"
            @click="copySelect"
          >
            Copy Signature
          </el-button>
        </el-button-group>
      </div>
    </div>
    <success-promo :show.sync="showSuccessPromo" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SuccessPromo from './SuccessPromo'

export default {
  name: 'Preview',

  components: {
    SuccessPromo
  },

  data () {
    return {
      html: '',
      showSource: false,
      showSuccessPromo: false,
      version: require('../../package.json').version
    }
  },

  computed: {
    ...mapState(['template', 'company', 'address']),
    ...mapGetters({
      basic: 'getBasic',
      company: 'getCompany',
      options: 'getOptions',
      address: 'getAddress',
      template: 'getTemplate'
    }),
    signatureTemplate () {
      return () => import(`./templates/${this.template.selected}`)
    },
    selectTemplate: {
      get () {
        return this.template.selected
      },
      set (v) {
        this.$store.dispatch('updateTemplate', v)
      }
    },
    selectCompany: {
      get () {
        return this.company.selected
      },
      set (v) {
        this.address.selected = null
        this.address.selectedObj = null
        this.$store.dispatch('updateCompany', v)
        this.$store.dispatch('updateAddress', v)
        if (this.address.selectedBranchAddresses.length > 0) {
          this.$store.dispatch('updateSelectedAddress', this.address.selectedBranchAddresses[0].branch)
        }
      }
    },
    isBranchAddressEmpty () {
      return this.address.selectedBranchAddresses.length === 0
    },
    isSelectAddressEmpty () {
      return !this.selectAddress || (typeof this.selectAddress === 'string' && this.selectAddress.trim() === '') || (Array.isArray(this.selectAddress) && this.selectAddress.length === 0)
    },
    selectAddress: {
      get () {
        return this.address.selected
      },
      set (v) {
        this.$store.dispatch('updateSelectedAddress', v)
      }
    }
  },

  mounted () {
    if (this.isBranchAddressEmpty) {
      this.$store.dispatch('updateAddress', this.selectCompany)
      this.$store.dispatch('updateSelectedAddress', this.address.selectedBranchAddresses[0].branch)
    }
  },

  methods: {
    copySelect () {
      if (window.getSelection) {
        let range = document.createRange()
        range.selectNode(this.$refs.preview.querySelector('.email-preview div'))
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
        document.execCommand('copy')
        this.showSuccessPromo = true
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

$padding-inner: 40px 50px 20px 50px;

.preview {
  background-color: #f6f6f6;
  overflow-y: auto;
  display: grid;
  grid-template-rows: 1fr 50px;
  &__header {
    margin-bottom: 20px;
  }
  &__inner {
    max-width: 900px;
    padding: $padding-inner;
  }
  &__footer {
    max-width: 900px;
    text-align: right;
    align-self: flex-end;
    padding: $padding-inner;
  }
  h2 {
    line-height: 0;
  }
  p {
    margin: 0;
  }
  .actions {
    text-align: right;
    margin-top: 20px;
  }
}
.email {
  min-height: 350px;
  width: 100%;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  &-content {
    padding: 20px;
    p {
      line-height: 1.5em;
      margin-bottom: 10px;
      font-size: 13px;
    }
    .line {
      height: 10px;
      background-color: #eee;
      margin: 10px 0;
      border-radius: 2px;
      &.short {
        width: 30%;
      }
      &.long {
        width: 90%;
      }
      &.half {
        width: 50%;
      }
      &.full {
        width: 100%;
      }
    }
    .flex {
      display: flex;
      width: 100%;
      margin-bottom: -10px;
      .column-1 {
        .line {
          &:first-of-type {
            margin-top: 0;
          }
        }
      }
      .column-1,
      .column-2 {
        flex-grow: 1;
      }
      .column-1 {
        width: 100%;
      }
      .column-2 {
        flex-shrink: 0;
        min-width: 320px;
      }
    }
  }
  &-preview {
    padding: 20px;
  }
  .placeholder {
    height: 100px;
    width: 100px;
    background-color: #eee;
    line-height: 0;
    font-size: 0;
  }
}
.setup-instruction {
  font-size: 12px;
}
.dialog-actions {
  text-align: right;
  margin-top: 20px;
}
.version {
  color: #aaa;
  margin-top: 10px;
  font-size: 12px;
  a {
    color: #aaa;
  }
  span {
    + span {
      &::before {
        content: "•";
        padding: 0 5px;
      }
    }
  }
  svg {
    width: 20px;
    position: relative;
    top: 5px;
    transition: all 0.2s;
  }
}
.link {
  text-decoration: underline;
  color: $color-primary;
  cursor: pointer;
}
</style>
